module.exports = __webpack_public_path__ + "assets/img/step8-3.fbe21522.png";